(() => {
  const body = document.querySelector('.cj-article-body');
  const nav = document.querySelector('[data-editorial-toc]');
  if (!body || !nav) return;
  const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
  headings.slice(0, 12).forEach((heading, index) => {
    if (!heading.id) heading.id = `article-section-${index + 1}`;
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${heading.id}`;
    a.textContent = heading.textContent.trim();
    li.append(a); nav.querySelector('ol').append(li);
  });
  if (headings.length) {
    nav.hidden = false;
    body.querySelectorAll('.journal-toc').forEach(n => n.hidden = true);
  }
  if (!document.getElementById('timeline')) {
    const target = headings.find(h => /时间|多久|週|周|期待|结果|效果/.test(h.textContent));
    body.querySelectorAll('a[href="#timeline"]').forEach(a => {
      a.href = target ? `#${target.id}` : '#journal-body';
    });
  }
  body.querySelectorAll('table').forEach(table => {
    const wrap = document.createElement('div');
    wrap.className = 'cj-table-scroll';
    wrap.tabIndex = 0;
    table.before(wrap); wrap.append(table);
  });
})();
